import { getService } from 'data/function';
export class SharedToastsProcessor {
    static get SharedToastsService() {
        return getService('SharedToastsService');
    }
    static async process({ message }) {
        SharedToastsProcessor.SharedToastsService.showUploadErrorToast(message.content);
    }
}
